import { render, staticRenderFns } from "./u-mobile-header-fixed.vue?vue&type=template&id=f62e8630&scoped=true"
import script from "./u-mobile-header-fixed.vue?vue&type=script&lang=js"
export * from "./u-mobile-header-fixed.vue?vue&type=script&lang=js"
import style0 from "./u-mobile-header-fixed.vue?vue&type=style&index=0&id=f62e8630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62e8630",
  null
  
)

export default component.exports